import { Language } from '@coolblue-development/constants';
import { createInstance } from 'i18next';
import I18nInstanceRepository from '../global/I18nInstanceRepository.js';
import TranslationsRepository from '../global/TranslationsRepository.js';
import { applyVariations } from './applyVariations.js';
import { getNamespace } from './getNamespace.js';
export const getI18nInstance = async (language) => {
    let instance = I18nInstanceRepository.getInstance(language);
    if (!instance) {
        instance = await createI18nInstance(language);
        I18nInstanceRepository.storeInstance(instance, language);
    }
    return await addBundle(instance, language);
};
const createI18nInstance = async (language) => {
    const instance = createInstance();
    await instance.init({
        supportedLngs: Object.values(Language),
        fallbackLng: Language.DUTCH,
        lng: language,
        resources: {}, // Should be empty because we use `addResourceBundle`
    });
    return instance;
};
/**
 * We want to add the variations to every call to `getInstance`,
 * as each ECS Task may handle various requests at the same time.
 * Therefore, we can not apply variations simply for a single request,
 * without creating an enormous amount of instances which will have memory ramifications.
 */
const addBundle = async (instance, language) => {
    const translations = await applyVariations(TranslationsRepository.getTranslationsMap()[language], language);
    return instance.addResourceBundle(language, getNamespace(instance), translations, true, true);
};
//# sourceMappingURL=getI18nInstance.js.map